// extracted by mini-css-extract-plugin
export default {"logo":"Rodape_logo__GFl1B","rodape":"Rodape_rodape__KW9FB","texto":"Rodape_texto__4WfHn","redes_sociais":"Rodape_redes_sociais__Nggtl","icone":"Rodape_icone__8Dltp"};